/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from "react";
import { Button, Card, Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import CButton from "../../../../components/buttons/Button";
import CDataTable from "../../../../components/datatable/datatable";
import {
  BusinessList,
  OngoingOrderList,
  PublishOrderHook,
  RejectOrderHook,
} from "../hooks/myPortalHooks";
import { LoadingContext } from "../../../../context/loadingContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faPencil,
  faXmarkCircle,
} from "@fortawesome/free-solid-svg-icons";
import CUrlField from "../../../../components/inputBoxes/url-input";
import CDateField from "../../../../components/inputBoxes/date";
import { downloadFileHooks } from "../../newOrders/hooks/newOrderHooks";
import MyPortalMobile from "./myPortalMobile";
import ReactPaginate from "react-paginate";

const DashboardMyPortal = () => {
  const navigate = useNavigate();
  const { setLoading } = useContext(LoadingContext);
  const [businessList, setBusinessList] = useState([]);
  const [ongoingOrderList, setOngoingOrderList] = useState();
  const [showModal, setShowModal] = useState(false);
  const [publishedPostDetails, setPublishedPostDetails] = useState();
  const [ApproveOrderId, setApproveorderId] = useState();
  const [mktEmailId, setMktEmailId] = useState();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  sessionStorage.setItem("login", true);

  useEffect(() => {
    setLoading(true);
    (async () => {
      window.addEventListener("resize", () => {
        setWindowWidth(window.innerWidth);
      });

      // List of approved domains using BusinessList

      const List = await BusinessList();

      // Processing orders list using OngoingOrderList

      const orderList = await OngoingOrderList();
      setBusinessList(List);
      setOngoingOrderList(orderList.data);
      setLoading(false);
      if (window.innerWidth <= 992)
        document.getElementById("sidebarToggle").click();
    })();
    return () => {
      // this now gets called when the component unmounts
    };
  }, []);

  // Approving order to publish using PublishOrderHook

  const ApproveOrder = async () => {
    setLoading(true);
    const result = await PublishOrderHook({
      doi_id: ApproveOrderId,
      mkt_email: mktEmailId,
      post_url: publishedPostDetails.post_url,
      posted_date: publishedPostDetails.posted_date,
    });
    if (result.status === 200) {
      const list = await OngoingOrderList();
      setOngoingOrderList(list.data);
      setLoading(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setShowModal(false);
    ApproveOrder();
  };

  // Rejecting order not to publish using RejectOrderHook

  const RejectOrder = async (order_id) => {
    setLoading(true);
    const result = await RejectOrderHook({ order_id: order_id });
    if (result.status === 200) {
      const list = await OngoingOrderList();
      setOngoingOrderList(list.data);
      window.location.reload();
      setLoading(false);
    }
  };

  const setEdit = async (mpi_id) => {
    navigate(`add-new-business/${mpi_id}`);
  };

  const HandleFieldsValue = (key, value) => {
    setPublishedPostDetails({ ...publishedPostDetails, [key]: value });
  };

  const downloadFile = async (order_id) => {
    setLoading(true);
    const result = await downloadFileHooks(order_id);
    setLoading(false);
    const downloadBtn = document.getElementById("download-btn");
    downloadBtn.href = result;
    downloadBtn.click();
  };

  function PaginatedItems({ itemsPerPage, items }) {
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.
    const [itemOffset, setItemOffset] = useState(0);

    // Simulate fetching items from another resources.
    // (This could be items from props; or items loaded in a local state
    // from an API endpoint with useEffect and useState)
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    const currentItems = items.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(items.length / itemsPerPage);

    // Invoke when user click to request another page.
    const handlePageClick = (event) => {
      const newOffset = (event.selected * itemsPerPage) % items.length;
      console.log(
        `User requested page number ${event.selected}, which is offset ${newOffset}`
      );
      setItemOffset(newOffset);
    };

    return (
      <>
        <Items currentItems={currentItems} />
        <ReactPaginate
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={1}
          marginPagesDisplayed={1}
          pageCount={pageCount}
          previousLabel="< previous"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination justify-content-center"
          activeClassName="active"
          renderOnZeroPageCount={null}
        />
      </>
    );
  }

  function Items({ currentItems }) {
    return (
      <>
        {currentItems &&
          currentItems.map((values) => (
            <>
              <h6 className="text-dark mb-3 fw-bolder">
                Registered Domain: {values.portal_url}
                <FontAwesomeIcon
                  icon={faPencil}
                  className={"ms-2 text-success"}
                  onClick={() => setEdit(values.mpi_id)}
                />
              </h6>
              <div className="col-md-6 col-sm-12 text-dark">
                {values.data_pub_siteinfos[0]
                  ? values.data_pub_siteinfos[0]["description"]
                  : ""}
              </div>
              <div className="col-md-6 col-sm-12 d-flex justify-content-center">
                <Card className="shadow shadow-right border-0 bg-primary-soft text-center mb-5">
                  <Card.Body>
                    <Card.Title className="fw-bold ps-4 pe-4 mt-3 text-dark">
                      Monthly Earnings:
                    </Card.Title>
                    <Card.Text className="fw-bold text-primary">
                      $0.00
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            </>
          ))}
      </>
    );
  }

  return (
    <>
      {windowWidth >= 922 ? (
        <>
          <div className="row">
            <h4 className="text-dark mb-5 fw-bolder text-center">Dashboard</h4>
            <Items />
            <PaginatedItems
              itemsPerPage={2}
              items={
                businessList.length !== 0 && businessList.data
                  ? businessList.data
                  : []
              }
            />
            <Link to="/dashboard/add-new-business">
              <CButton
                btnClassesDiv={"text-center mt-4 mb-5"}
                btnClasses={"btn px-4 fw-bold text-white"}
                IsOutline={false}
                innertext={"Add new Business"}
                btnCustomStyle={{
                  backgroundColor: "#044389",
                }}
              />
            </Link>
          </div>
          {ongoingOrderList !== undefined ? (
            <>
              <h4 className="text-dark text-center fw-bold">On Going Orders</h4>
              <CDataTable
                column={[
                  {
                    name: "S.No",
                    selector: (row, index) => index + 1,
                    center: true,
                  },
                  {
                    name: "Date",
                    selector: (row) => row.order_date.split("T")[0],
                    sortable: true,
                    center: true,
                  },
                  {
                    name: "Order#",
                    selector: (row) => row.doi_id,
                    center: true,
                  },
                  {
                    name: "Article",
                    selector: (row) => (
                      <CButton
                        btnClasses={
                          "btn btn-sm text-decoration-none text-light"
                        }
                        btnCustomStyle={{
                          backgroundColor: "#044389",
                        }}
                        innertext={"View File"}
                        functionName={() => downloadFile(row.doi_id)}
                      />
                    ),
                    center: true,
                    width: "180px",
                  },
                  {
                    name: "Advertiser",
                    selector: (row) =>
                      row.data_mkt_reg.firstname +
                      " " +
                      row.data_mkt_reg.lastname,
                    center: true,
                  },
                  {
                    name: "Status",
                    selector: (row) => row.master_order_status.name,
                    center: true,
                    sortable: true,
                  },
                  // {
                  //   name: "Payment",
                  //   selector: (row) =>
                  //     row.trxn_order_payment_statuses[0]["master_payment_status"][
                  //       "name"
                  //     ],
                  //   center: true,
                  // },
                  {
                    name: "Action",
                    selector: (row) =>
                      row.master_order_status.name === "Processing" ? (
                        <>
                          <div className="row">
                            <div className="col-6">
                              <FontAwesomeIcon
                                icon={faCheckCircle}
                                className="text-success fa-2x"
                                onClick={() => {
                                  setShowModal(true);
                                  setApproveorderId(row.doi_id);
                                  setMktEmailId(row.data_mkt_reg.email);
                                }}
                              />
                            </div>
                            <div className="col-6">
                              <FontAwesomeIcon
                                icon={faXmarkCircle}
                                className="text-danger fa-2x"
                                onClick={() => RejectOrder(row.doi_id)}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      ),
                    center: true,
                  },
                ]}
                data={ongoingOrderList}
                isHover={true}
                isPagination={true}
                paginationPerPage={5}
                paginationRowsPerPageOptions={[5, 10, 15, 20]}
                isResponsive={true}
                customClassLabel={"fw-bold text-dark mb-3"}
                customClassDiv={"mb-4"}
                persistTableHead={true}
                fixedHeader={true}
              />
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        <>
          <MyPortalMobile
            ongoingOrderList={ongoingOrderList}
            businessList={businessList}
            downloadFile={(id) => downloadFile(id)}
            setShowModal={(status) => setShowModal(status)}
            setApproveorderId={(id) => setApproveorderId(id)}
            RejectOrder={(id) => RejectOrder(id)}
            setEdit={(id) => setEdit(id)}
          />
        </>
      )}
      <a href="" className="d-none" id="download-btn"></a>

      <Modal
        show={showModal}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title className="text-dark">Published details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <CUrlField
              required={true}
              labelName={"Post URL"}
              name={"post_url"}
              customClassDiv={"text-dark fs-5 "}
              customClassInput={"bg-primary-soft"}
              functionName={(name, domain_url) =>
                HandleFieldsValue(name, domain_url)
              }
            />
            <CDateField
              required={true}
              labelName={"Posted Date"}
              name={"posted_date"}
              customClassDiv={"text-dark mt-3 fs-5"}
              customClassInput={"bg-primary-soft"}
              functionName={(name, domain_url) =>
                HandleFieldsValue(name, domain_url)
              }
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="danger"
              onClick={() => {
                setShowModal(false);
              }}
            >
              Close
            </Button>
            <Button type="submit" variant="success">
              Confirm
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
export default DashboardMyPortal;
